var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaisingFundsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 29.3333C26.3486 29.3333 29.3333 26.3486 29.3333 22.6667C29.3333 18.9848 26.3486 16 22.6667 16C18.9848 16 16 18.9848 16 22.6667C16 26.3486 18.9848 29.3333 22.6667 29.3333Z",
    fill: "#F3B763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 22.6667C15.9974 26.3486 18.9822 29.3333 22.6641 29.3333C26.346 29.3333 29.3307 26.3486 29.3307 22.6667C29.3307 18.9848 26.346 16 22.6641 16C18.9822 16 15.9974 18.9848 15.9974 22.6667ZM15.9974 22.6667C15.9974 21.1656 16.4935 19.7803 17.3307 18.666V6.66667M15.9974 22.6667C15.9974 23.7671 16.264 24.8053 16.7362 25.7202C15.613 26.669 13.0185 27.3333 9.9974 27.3333C5.94731 27.3333 2.66406 26.1394 2.66406 24.6667V6.66667M17.3307 6.66667C17.3307 8.13943 14.0475 9.33333 9.9974 9.33333C5.94731 9.33333 2.66406 8.13943 2.66406 6.66667M17.3307 6.66667C17.3307 5.19391 14.0475 4 9.9974 4C5.94731 4 2.66406 5.19391 2.66406 6.66667M2.66406 18.6667C2.66406 20.1394 5.94731 21.3333 9.9974 21.3333C12.9161 21.3333 15.4365 20.7133 16.6169 19.8157M17.3307 12.6667C17.3307 14.1394 14.0475 15.3333 9.9974 15.3333C5.94731 15.3333 2.66406 14.1394 2.66406 12.6667",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisingFundsIcon);
export default __webpack_public_path__ + "static/media/raising-funds-icon.f6877d942206b256f582397b57c99f45.svg";
export { ForwardRef as ReactComponent };